/**
 * Rótulo do controle (evidência) nas telas de documento.
 *
 * Evidências criadas manualmente antes da validação de nome obrigatório ficaram sem título no banco, e
 * as duas telas que listam controles as exibem justamente pelo título — sem um rótulo de reserva elas
 * apareciam como linha/opção em branco, indistinguíveis entre si e impossíveis de selecionar.
 */
const mountControlLabel = (evidence) =>
  evidence?.title || (evidence?.id ? `Controle sem nome #${evidence.id}` : '')

export default mountControlLabel
